import _ from "lodash";
import {fieldPathJoinGetter} from "../../../utils/kp3Utils";

export const entities = [
    {
        name: 'AgeInterval',
        fields: [
            {path: 'minAge', type: 'integer'},
            {path: 'maxAge', type: 'integer'},
            {path: 'bracket', type: 'AgeBracket'},
            fieldPathJoinGetter({path: 'name', fieldPath: ['minAge', 'maxAge']})
        ],
        filters: [
            {
                name: 'byAnimalType',
                path: "animalType",
                object: "AnimalType",
                isDefault: false,
                query: function (context) {
                    const animalType = _.get(context, "data.animalType")

                    return animalType
                        ? {animalType: new global.ObjectID(animalType.id)}
                        : {_id: null}
                }
            },
        ]
    },
    {
        name: 'AnimalType',
        facets: [{name: 'codeName', nameOptional: false, uniqueName: true}],
        fields: [
            'AnimalTypeGroup',
            {path: 'ageIntervals', type: 'AgeInterval', link: {type: 'OTM', deleteType: 'cascade', onParent: true, onChild: true}}
        ],
        filters: [
            {
                name: 'byShelters',
                isDefault: false,
                query: (context) => {
                    const shelters = _.get(context, 'data.shelters') || []
                    return { _id: { $in: _.flatMap(shelters, shelter => (shelter.animalTypes || []).map(animalType => new global.ObjectID(animalType.id))) } }
                }
            },
            {
                name: 'byAnimalTypeGroup',
                isDefault: false,
                query: (context) => {
                    const animalTypeGroupId = _.get(context, 'data.animalTypeGroup.id')
                    return animalTypeGroupId
                        ? { animalTypeGroup: animalTypeGroupId }
                        : { _id: null }
                }
            },
            {
                name: 'byAnimalTypes',
                isDefault: false,
                query: function (context) {
                    const animalTypes = _.get(context, "data.animalTypes", [])

                    return animalTypes.length > 0
                        ? {_id: {$in: animalTypes.map(animalType => new global.ObjectID(animalType.id))}}
                        : {_id: null}
                }
            },
            {
                name: "byOrganizations",
                isDefault: false,
                query: (context) => {
                    const animalTypes = _.get(context, 'data.animalTypes')
                    return animalTypes && animalTypes.length
                        ? {_id: {$in: animalTypes.map(at => new global.ObjectID(at.id))}}
                        : {_id: null}
                }
            }
        ]
    }
]

export const module_ = {
    object: 'AnimalType',
    tKey: 'mTitle_animalType',
    defaultSortBy: 'code',
    defaultSortDirection: 'ASC',
    objectIdentifier: 'name',
    category: {
        path: 'mTitle_animals',
        icon: 'animal'
    },
    viewMap: {
        dt: [
            'code', 'name', 'animalTypeGroup'
        ],
        form: [
            'code', 'name', {path: 'animalTypeGroup', sortList: false, editable: false},
            {
                path: 'ageIntervals',
                type: 'accordion',
                required: true,
                defaultSortBy: 'minAge',
                defaultSortDirection: 'ASC',
                applyBoard: true,
                viewMap: {
                    dt: [
                        {path: 'minAge', tKey: 'ageFrom'}, {path: 'maxAge', tKey: 'ageTo'}, {path: 'bracket', tKey: 'ageBracket'}
                    ],
                    form: [
                        {path: 'minAge', tKey: 'ageFrom'}, {path: 'maxAge', tKey: 'ageTo'}, {path: 'bracket', tKey: 'ageBracket', required: true}
                    ]
                },
            },
            /*{
                path: 'ageIntervals',
                type: 'dtObjects',
                canAddRow: true,
                //applyBoard: true,
                fields: [{path: 'minAge', type: 'editText'}, {path: 'maxAge', type: 'editText'}],
            }*/
        ]
    }
}
